.form {
    display: flex;
    flex-direction: column;
    gap: var(--bi-scale-8x);
}

.field {
    flex: 1;
}

.horizontalFields {
    display: flex;
    gap: var(--bi-scale-8x);

    @media (width < 768px) {
        gap: var(--bi-scale-5x);
    }
}
